import { render, staticRenderFns } from "./WebsiteSetupModal.vue?vue&type=template&id=3bd4816b&"
import script from "./WebsiteSetupModal.vue?vue&type=script&lang=js&"
export * from "./WebsiteSetupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports